export interface APIList<T> {
  count: number;
  next: number;
  previous: number;
  results: T[];
}
